const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/com/eCheckin/sections/PersAngaben.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import textMap from '../translations';
import { CIS4mTextField } from '@cistec/common_web/modules/CIS4m/components/CIS4mTextField';
import textMapCommon from '../../../common/translations';
import { AddressBlock } from 'App/components/eCheckin/components/fields/AddressBlock';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { CountryField } from 'App/components/eCheckin/components/fields/metakat/CountryField';
import { atLeastOneHasValue } from '@cistec/common_web/modules/CIS4m/utils/data';
import { GenderField } from 'App/components/eCheckin/components/fields/metakat/GenderField';
import { ZivilstandField } from 'App/components/eCheckin/components/fields/metakat/ZivilstandField';
import { PhoneNumberField } from 'App/components/eCheckin/components/fields/PhoneNumberField';
import { EMailField } from 'App/components/eCheckin/components/fields/EMailField';
import { AHVField } from 'App/components/eCheckin/components/fields/AHVField';
import { BirthDateField } from 'App/components/eCheckin/components/fields/BirthDateField';
import { createFieldPath } from 'App/components/eCheckin/utils';
import { useText } from '@cistec/common_web/utils/intlUtils';

export const PersAngaben = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_FIRST_NAME = createFieldPath(path, 'firstname');
    const PATH_LAST_NAME = createFieldPath(path, 'lastname');
    const PATH_DATE_OF_BIRTH = createFieldPath(path, 'dateOfBirth');
    const PATH_COUNTRY = createFieldPath(path, 'country');
    const PATH_EMAIL = createFieldPath(path, 'email');
    const PATH_TEL = createFieldPath(path, 'tel');
    const PATH_MOBILE = createFieldPath(path, 'mobile');
    const PATH_GENDER = createFieldPath(path, 'geschlecht');
    const PATH_NATIONALITY = createFieldPath(path, 'nationality');
    const PATH_AHV = createFieldPath(path, 'ahv');
    const PATH_ZIVILSTAND = createFieldPath(path, 'zivilstand');
    const PATH_PROFESSION = createFieldPath(path, 'profession');

    const eCheckinSectionRef = useCIS4m(ref);
    const formData = useCIS4mData();

    const phoneNumberRequired = !atLeastOneHasValue(formData, [PATH_TEL, PATH_MOBILE]);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <CIS4mTextField label={textMapCommon.firstname} path={PATH_FIRST_NAME} required={true} />
            <CIS4mTextField label={textMapCommon.lastname} path={PATH_LAST_NAME} required={true} />
            <EMailField label={textMapCommon.email} path={PATH_EMAIL} required={true} />
            <AddressBlock basePath={path} required={true} />
            <PhoneNumberField
                label={textMapCommon.tel}
                path={PATH_TEL}
                required={phoneNumberRequired}
                countryCodePath={PATH_COUNTRY}
            />
            <PhoneNumberField
                label={textMapCommon.mobile}
                path={PATH_MOBILE}
                required={phoneNumberRequired}
                countryCodePath={PATH_COUNTRY}
            />
            <BirthDateField label={textMap.dateOfBirth} path={PATH_DATE_OF_BIRTH} required={true} />
            <GenderField path={PATH_GENDER} label={textMap.gender} />
            <ZivilstandField label={textMap.zivilstand} path={PATH_ZIVILSTAND} />
            <CountryField label={textMap.nationality} path={PATH_NATIONALITY} required={true} />
            <CIS4mTextField label={textMap.profession} path={PATH_PROFESSION} required={true} />
            <AHVField label={textMap.ahv} path={PATH_AHV} required={true} />
        </ECheckinSection>
    );
});

PersAngaben.displayName = 'PersAngaben';

export default PersAngaben;
